import type { FaireProductEntity } from "../../entity_types/product";

export const p_3eiqk6c2r8: FaireProductEntity = {
  token: "p_3eiqk6c2r8",
  type: "product",
  name: "Sparkler Wish Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/426c21070ae4e725a97480244769f66f276f56f816311edd0519dc03be17e93a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/afdfca837690dafa3dacf40c67f8a69aefd89e9a0855298c1dfe87ae3561aec6.jpeg",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:24.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
